import { MdEmail, MdPhone, MdLanguage } from "react-icons/md";

const TopCards = () => {
  return (
    <div className="relative mb-10">
      {/* Cards Grid */}
      <div className="flex justify-center gap-6 md:gap-8 px-2 md:px-4 flex-wrap">
        
        {/* India */}
        <div className="bg-white shadow rounded-xl p-4 sm:p-6 md:p-8 
                        w-full sm:w-72 md:w-88 h-auto sm:h-[420px] lg:h-[500px]
                        flex flex-col items-center sm:items-start text-center sm:text-left
                        transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl">
          {/* Location Icon */}
          <div className="flex justify-center sm:justify-start mb-3 w-full">
            <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-[#FFF4EA]">
              <img
                src="/img/contact_locationicon_img.png"
                alt="Location Icon"
                className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10"
              />
            </div>
          </div>

          <h2 className="text-xl sm:text-2xl md:text-[24-px] font-bold text-gray-900  mt-4">
            India
          </h2>
          <p className="mt-3 sm:mt-4 text-sm sm:text-base md:text-[14px] text-justify">
            <b>Corporate Office </b>- 2nd Floor , Vamsiram Jyothi Celesta Plot # 66, Kavuri Hills, Jubilee Hills, Hyderabad, Telangana 500033
          </p>
          <p className="mt-3 sm:mt-4 text-sm sm:text-base md:text-[14px] text-justify">
            <b>Manufacturing Plant </b>: # 368 & 375, APIIC Industrial Growth Centre, Gundlapalli-523211, Andhra Pradesh, INDIA 
          </p>

          {/* Contact Info */}
          <div className="mt-auto pt-4 space-y-3">
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <span className="w-8 h-8 flex mt-[-20px] items-center justify-center rounded-full bg-primary text-white">
                <MdEmail size={16} />
              </span>
              <a href="mailto:info@intronlifesciences.com" className="hover:underline">
                info@intronlifesciences.com
              </a>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <span className="w-8 h-8 flex items-center mt-[-20px] justify-center rounded-full bg-primary text-white">
                <MdPhone size={16} />
              </span>
              <a href="tel:+918801230123" className="hover:underline">
                +91-8801230123
              </a>
            </div>
          </div>
        </div>

        {/* Vietnam */}
        <div className="bg-white shadow rounded-xl p-4 sm:p-6 md:p-8 
                        w-full sm:w-72 md:w-88 h-auto sm:h-[420px] lg:h-[500px]
                        flex flex-col items-center sm:items-start text-center sm:text-left
                        transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl">
          
          {/* Location Icon */}
          <div className="flex justify-center sm:justify-start mb-3 w-full">
            <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-[#FFF4EA]">
              <img
                src="/img/contact_locationicon_img.png"
                alt="Location Icon"
                className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10"
              />
            </div>
          </div>

          <h2 className="text-xl sm:text-2xl md:text-[24px] font-bold text-gray-900 mt-4 ">
            Vietnam
          </h2>
          <p className="mt-3 sm:mt-4 text-sm md:text-[14px] sm:text-base text-justify">
            Intron Life Sciences Vietnam Company Limited, S14 đường 19, KDC Phước Kiển A, xã Phước Kiển, huyện Nhà Bè, TP.Hồ Chí Minh,
          </p>

          <div className="mt-auto pt-6 space-y-3">
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <span className="w-8 h-8 flex items-center mt-[-20px] justify-center rounded-full bg-primary text-white">
                <MdLanguage size={16} />
              </span>
              <a 
                href="https://intronvn.com/" 
                target="_blank" 
                rel="noopener noreferrer" 
                className="hover:underline"
              >
                intronvn.com
              </a>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <span className="w-8 h-8 flex items-center mt-[-20px] justify-center rounded-full bg-primary text-white">
                <MdEmail size={16} />
              </span>
              <a href="mailto:info.vietnam@intronlifesciences.com" className="hover:underline">
                info.vietnam@intronlifesciences.com
              </a>
            </div>
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <span className="w-8 h-8 flex items-center mt-[-20px] justify-center rounded-full bg-primary text-white">
                <MdPhone size={16} />
              </span>
               <a href="tel:+842836366229" className="hover:underline">
                +84-2836366229
              </a>
            </div>
          </div>
        </div>

        {/* Singapore */}
        <div className="bg-white shadow rounded-xl p-4 sm:p-6 md:p-8 
                        w-full sm:w-72 md:w-88 h-auto sm:h-[420px] lg:h-[500px]
                        flex flex-col items-center sm:items-start text-center sm:text-left
                        transition-all duration-300 transform hover:-translate-y-2 hover:shadow-2xl">
          
          {/* Location Icon */}
          <div className="flex justify-center sm:justify-start mb-3 w-full">
            <div className="w-14 h-14 sm:w-16 sm:h-16 md:w-20 md:h-20 flex items-center justify-center rounded-full bg-[#FFF4EA]">
              <img
                src="/img/contact_locationicon_img.png"
                alt="Location Icon"
                className="w-7 h-7 sm:w-8 sm:h-8 md:w-10 md:h-10"
              />
            </div>
          </div>

          <h2 className="text-xl sm:text-2xl md:text-[24px] font-bold text-gray-900 mt-4">
            Singapore
          </h2>
          <p className="mt-3 sm:mt-4 text-sm sm:text-base md:text-[14px] text-justify">
            Intron Holdings Asia Pte. Ltd. 36 Robinson Road, #20-01 City House, Singapore 068877
          </p>

          <div className="mt-auto pt-6 space-y-3">
            <div className="flex items-center gap-3 text-sm text-gray-700">
              <span className="w-8 h-8 mt-[-20px] flex items-center justify-center rounded-full bg-primary text-white">
                <MdEmail size={16} />
              </span>
              <a href="mailto:info.singapore@intronlifesciences.com" className="hover:underline">
                info.singapore@intronlifesciences.com
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Decorative Circle */}
      <div className="hidden lg:block absolute -top-20 right-0 mr-10 h-[130px] w-[130px] bg-primary rounded-full z-0 float-animation" />
    </div>
  );
};

export default TopCards;
